import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Inject,
  ViewChild,
} from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute } from '@angular/router';
import { CommonService } from 'src/app/shared/services/common.service';
import { BankTransactionsService } from './bank-transactions.service';
import { MatSort, Sort, SortDirection } from '@angular/material/sort';
import { Location } from '@angular/common';
import { MatPaginator } from '@angular/material/paginator';
import { BehaviorSubject, merge, of as observableOf, Subject, Subscription } from 'rxjs';
import {
  catchError,
  map,
  startWith,
  switchMap,
  debounceTime,
  tap,
  auditTime,
} from 'rxjs/operators';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';
import { MatDialog } from '@angular/material/dialog';
import { IFilterMenu } from 'src/app/shared/components/FilterMenu/filter-menu.model';
import {
  CounterPartyLabelComponent,
  BankAccountLabelComponent,
} from './custom-label.component';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { DialogComponent } from 'src/app/shared/components/dialog/dialog.component';
import { ModalDialogData } from 'src/app/models/modelDialog.model';
import { ConfigService } from '../../../initializer/config.service';
import { MatCheckboxChange } from '@angular/material/checkbox';

interface ITransactions {
  id: string;
  accountId: string;
  account: string;
  currency: string;
  amount: number;
  purpose: string;
  name: string;
  date: string;
}

export const MY_DATE_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};
interface SubItem {
  name?: string;
  selected?: boolean;
  count?: number;
  accountNo?: number;
}
@Component({
  selector: 'app-bank-transactions',
  templateUrl: './bank-transactions.component.html',
  styleUrls: ['./bank-transactions.component.scss'],
  providers: [{ provide: MAT_DATE_FORMATS, useValue: MY_DATE_FORMATS }],
})
export class BankTransactionsComponent implements AfterViewInit {
  search: string;
  vehicleId: string;
  gpId: string;
  transactionId: string | undefined;
  selecetdTransaction: any;
  displayedColumns: string[] = [
    'bookingDate',
    'purpose',
    'amount',
    'currency',
    'partnerName',
    'bankAccount',
    'attachment',
    'details',
    // 'accountId'
  ];
  dataSource: MatTableDataSource<any> = new MatTableDataSource([] as any);
  totalRecords = 0;
  transactions: ITransactions[] = [];
  noTransactions = false;
  bankAccount: any | null;
  accountList: any;
  filters: BehaviorSubject<any> = new BehaviorSubject<any>({});
  refresh: BehaviorSubject<any> = new BehaviorSubject<string>('');
  isLoading = true;
  isClearBtn = false;
  isPageLoading = false;
  isDownloading = false;
  isSyncInProgress = false;
  amountType = '';
  rowHeight = 60; // Adjust row height as per your table styles
  searchSubject = new Subject<boolean>();
  maxDate: Date = new Date();
  monthsBack = 6;
  showExportTooltip = true;
  currentFilterOrder: SortDirection = 'desc';
  private refreshParent: Subscription;
  selectedVehicle: any;
  selectedGP: any = {};

  range = new FormGroup({
    start: new FormControl<Date | null>(null),
    end: new FormControl<Date | null>(null),
  });

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('tableSection', { static: false }) tableSection!: ElementRef;
  @ViewChild('paginator', { static: false }) paginator!: MatPaginator;
  @ViewChild('subFilterSelect') subFilterSelect: MatSelect;

  pageSize = 10;
  updatePageSize = false;
  selectedFilters: any[] = [];
  filterMenuItems: IFilterMenu[] = [];

  constructor(
    private dialog: MatDialog,
    private activatedRoute: ActivatedRoute,
    private _location: Location,
    public commonService: CommonService,
    private bankTransactionsService: BankTransactionsService,
    private cdr: ChangeDetectorRef,
    private config: ConfigService
  ) {}

  ngOnInit() {
    this.vehicleId = this.activatedRoute.snapshot.params['vehicleId'];
    this.gpId = this.activatedRoute.snapshot.params['gpId'];
    this.transactionId = this.activatedRoute.snapshot.params['transactionId'];
    const baseconfigData = this.config.baseData.data;
    this.selectedGP = baseconfigData.gps.find((item: any) => item.id === this.gpId);
    this.selectedVehicle = this.selectedGP.vehicles.find(
      (item: any) => item.id === this.vehicleId
    );

    if(this.selectedVehicle) {
      this.bankTransactionsService.selectedVehicle.next(this.selectedVehicle);
    }
    setTimeout(() => {
      this.commonService.setSecondaryPath(['Bank']);
    }, 0);
    this.searchSubject.pipe(debounceTime(1000)).subscribe(flag => {
      flag && this.searchFilter();
    });
    this.filters.subscribe(filters => {
      if (
        filters &&
        filters.order &&
        (filters.order === 'asc' || filters.order === 'desc')
      ) {
        this.currentFilterOrder = filters.order;
      } else {
        this.currentFilterOrder = 'desc';
      }
    });
    this.refreshParent = this.bankTransactionsService.openTransactionDrawerFlag?.subscribe(
        isOpen => {
          if (!isOpen) {
            if (this.bankTransactionsService.shouldTriggerRefreshOnClose) {
              // this.refresh.next(true);
              this.bankTransactionsService.shouldTriggerRefreshOnClose = false;
            }
          }
        }
    );
    this.bankTransactionsService.transationListRefreshObservable$?.subscribe((res: boolean) => {
      if (res) {
        this.refresh.next('refresh');
      }
    })    
  }
  
  sortChange() {
    this.filters.next({
      ...this.filters.getValue(),
      sortBy: this.sort.active,
      order: this.sort.direction,
    });
  }

  ngAfterViewInit() {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));

    // Handle sort changes, paginator changes, and filter updates in merge
    merge(this.sort.sortChange, this.paginator.page, this.filters, this.refresh)
      .pipe(
        startWith({}), // Emit an initial empty object when the stream starts
        auditTime(100),
        tap(() => this.adjustPageSize()),
        switchMap(() => this.loadTransactions()),
        catchError(() => observableOf([]))
      )
      .subscribe(data => {
        this.dataSource.data = data;
      });
  }

  adjustPageSize() {
    const availableHeight =
      this.tableSection.nativeElement.offsetHeight - 70 - 45;
    const rowsPerPage = Math.floor(availableHeight / this.rowHeight);
    const roundedRowsPerPage = Math.ceil(rowsPerPage / 5) * 5;
    this.pageSize = Math.max(roundedRowsPerPage, 10);
    this.paginator.pageSize = this.pageSize;
    this.updatePageSize = true;
  }

  // // Method to calculate the total selected filters (main items + sub-items)
  // getSelectedFilterCount(): number {
  //   let count = this.selectedFilters.length;
  //   this.selectedFilters.forEach((item: any) => {
  //     count += item['selectedSubItems']?.length;
  //   });
  //   return count;
  // }
  getQueryKey(parentValue: string): string {
    return parentValue; // default
  }
  getQueryParams() {
    const queryParams: string[] = [];
    this.selectedFilters.forEach((item: any) => {
      const queryKey = this.getQueryKey(item.parentValue);
      item.selectedChildren.forEach((value: any) => {
        queryParams.push(`${queryKey}=${encodeURIComponent(value)}`);
      });
    });
    return queryParams.join('&');
  }
  getRequestPayload() {
    const filters: any = {};

    this.selectedFilters.forEach((item: any) => {
        const queryKey = this.getQueryKey(item.parentValue);
        filters[queryKey] = item.selectedChildren; // Directly map values to the key
    });
    return filters;
  }

  filterApplied(filters: any) {
    this.selectedFilters = filters;
    this.paginator.pageIndex = 0;
    this.refresh.next('refresh');
  }
  isPayloadEmpty(obj: Record<string, any>): boolean {
    return Object.keys(obj).length === 0;
  }
  loadTransactions() {
    const filters = this.filters.getValue();
    const payloadFilters = this.getRequestPayload();
    
    let isFilterApplied = Object.values(filters).some(value => value);
    if(!this.isPayloadEmpty(payloadFilters)) {
      isFilterApplied = true;
    }

    if (this.dataSource.data.length > 0 || isFilterApplied || this.isClearBtn) {
      this.isPageLoading = true; // Show pagination loader
    } else {
      this.isLoading = true; // Show initial loader
      this.isPageLoading = true;
      this.cdr.detectChanges();
    }

    return this.bankTransactionsService
      .getTransactions(
        this.vehicleId,
        this.sort.active,
        this.sort.direction,
        this.paginator.pageIndex,
        this.paginator.pageSize,
        filters,
        this.getRequestPayload(),
      )
      .pipe(
        map(data => {
          const isFilterApplied = Object.keys(filters).some(
            key => key !== 'order' && key !== 'sortBy'
          );
          this.filterMenuItems = [];
          const parsedResponse = JSON.parse(JSON.stringify(data));

          this.isLoading = false;
          this.isPageLoading = false;
          this.isClearBtn = false;
          this.totalRecords = parsedResponse.data.count;

          if (data === null) {
            return [];
          }

          if (isFilterApplied) {
            this.showExportTooltip = false;
          }

          // Process data and handle account list if no filter is applied
          if (!isFilterApplied) {
            this.showExportTooltip = true;
            this.noTransactions = !parsedResponse.data.count;
            this.noTransactions = !parsedResponse.data.lastSynced;
          }

          if (parsedResponse.data.accounts) {
            this.filterMenuItems.push({
              label: 'Bank account',
              value: 'iban',
              children: parsedResponse.data.accounts.map((account: any) => ({
                label: BankAccountLabelComponent,
                value: account?.accountNo,
                count: account?.count,
                labelProps: {
                  name: account?.bank,
                  accountNo: account?.accountNo,
                },
              })),
            });
          }

          if (parsedResponse.data.transactionType) {
            this.filterMenuItems.push({
              label: 'Transaction type',
              value: 'transactionType',
              children: parsedResponse.data.transactionType.map(
                (transactionType: any) => ({
                  label: transactionType?.name,
                  value: transactionType?.name,
                  count: transactionType?.count,
                })
              ),
            });
          }

          if (parsedResponse.data.counterparty) {
            this.filterMenuItems.push({
              label: 'Counterparty',
              value: 'counterparty',
              children: parsedResponse.data.counterparty.map(
                (counterparty: any) => ({
                  label: CounterPartyLabelComponent,
                  value: counterparty?.name,
                  count: counterparty?.count,
                  labelProps: {
                    name: counterparty?.name,
                    count: counterparty?.count,
                  },
                })
              ),
            });
          }

          return parsedResponse.data.transactions;
        })
      );
  }

  searchHandler() {
    this.searchSubject.next(true);
  }

  searchFilter() {
    const filterValue = (this.search || '').trim().toLowerCase();
    if (filterValue) {
      this.filters.next({
        ...this.filters.getValue(),
        search: filterValue,
      });
    }
    this.paginator.pageIndex = 0;
  }
  // accountFilter(event: any) {
  //   if (this.bankAccount) {
  //     this.filters.next({
  //       ...this.filters.getValue(),
  //       iban: this.bankAccount.accountNo,
  //     });
  //     this.paginator.pageIndex = 0;
  //   }
  // }

  // amountFilter(amountType: string) {
  //   this.amountType = amountType;
  //   this.filters.next({
  //     ...this.filters.getValue(),
  //     transactionType: amountType,
  //   });
  //   this.paginator.pageIndex = 0;
  // }

  dateRangeFilter(startDate: any, endDate: any) {
    if (startDate.value && endDate.value) {
      const startDateString = this.commonService.convertDateFormat(
        startDate.value
      );
      const endDateString = this.commonService.convertDateFormat(endDate.value);
      this.filters.next({
        ...this.filters.getValue(),
        startDate: startDateString,
        endDate: endDateString,
      });
      this.paginator.pageIndex = 0;
    }
  }

  clearFilter(filterKey: string) {
    this.isClearBtn = true;
    if (filterKey === 'dateRange') {
      this.range.reset();
    }
    const currentFilters = this.filters.getValue();
    const updatedFilters = { ...currentFilters };

    if (filterKey === 'dateRange') {
      delete updatedFilters.startDate;
      delete updatedFilters.endDate;
    } else {
      delete updatedFilters[filterKey];
    }
    this.filters.next(updatedFilters);
    this.paginator.pageIndex = 0;
  }

  handleBackspaceClear(event: KeyboardEvent) {
    const filterValue = (this.search || '').trim().toLowerCase();
    // Detect backspace or delete, and reset the filter if the search is empty
    if ((event.key === 'Backspace' || event.key === 'Delete') && !filterValue) {
      this.clearFilter('search');
    }
  }

  syncTransactions() {
    this.isSyncInProgress = true;
    this.bankTransactionsService.syncTransaction(this.vehicleId).subscribe({
      next: response => {
        this.isSyncInProgress = false;
        this.refresh.next('refresh');
        this.commonService.successNotification(
          'Transactions synced successfully'
        );
      },
      error: error => {
        this.isSyncInProgress = false;
        this.commonService.errorNotification('Failed to sync transactions');
      },
      complete: () => {
        this.isSyncInProgress = false;
      },
    });
  }

  downloadExcel() {
    this.isDownloading = true;
    const filters = this.filters.getValue();
    const payloadFilters = this.getRequestPayload();
    
    let isFilterApplied = Object.values(filters).some(value => value);

    if(!this.isPayloadEmpty(payloadFilters)) {
      isFilterApplied = true;
    }
    if(!isFilterApplied) {
      const maxDate = new Date();
          const minDate = new Date();
          maxDate.setHours(0, 0, 0, 0);
          minDate.setHours(0, 0, 0, 0);
          // Subtract monthsBack from today's date
          minDate.setMonth(minDate.getMonth() - this.monthsBack);
          // Format them as 'YYYY-MM-DD'
          filters.startDate = minDate.toISOString().split('T')[0];
          filters.endDate = maxDate.toISOString().split('T')[0];
    }
    this.bankTransactionsService
      .getExcelFile(
        this.vehicleId,
        this.sort.active,
        this.sort.direction,
        this.paginator.pageIndex,
        this.paginator.pageSize,
        { ...filters, format: 'excel' },
        { ...payloadFilters },
      )
      .subscribe({
        next: res => {
          const blob = new Blob([res], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
          });

          const blobURL = URL.createObjectURL(blob);

          const a = document.createElement('a');
          a.href = blobURL;
          a.download = `${this.formatDate(new Date())} transactions`;
          a.click();

          URL.revokeObjectURL(blobURL);
          this.isDownloading = false;
        },
        error: err => {
          this.isDownloading = false;
          console.log(err);
        },
      });
  }

  getAmountClass(amount: number): string {
    if (amount < 0) {
      return 'negative-amt';
    } else if (amount > 0) {
      return 'positive-amt';
    }
    return '';
  }

  formatDate(date: Date) {
    // 2024-09-17
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  }
  navigateBack() {
    // this.backClick.emit();
  }

  showDetails(transaction: any) {
    const { account, amount, currency, bookingDate, purpose, paymentPartner } =
      transaction;
    const filteredTransaction = {
      account,
      amount,
      currency,
      bookingDate,
      purpose,
      paymentPartner,
    };
    this.selecetdTransaction = filteredTransaction;
    this._location.replaceState(
      `gp/${this.gpId}/vehicle/${this.vehicleId}/transactions/${transaction.id}`
    );
    this.transactionId = transaction.id;
  }

  hideDetails() {
    this.transactionId = undefined;
    this._location.replaceState(
      `gp/${this.gpId}/vehicle/${this.vehicleId}/transactions`
    );
    this.commonService.setSecondaryPath([]);
    // !this.transactions && this.getTransactions();
  }

  viewTransactions(data: any) {
    const { account, amount, currency, bookingDate, purpose, paymentPartner, transactionId, invoiceList} =
      data;
    const filteredTransaction = {
      account,
      amount,
      currency,
      bookingDate,
      purpose,
      paymentPartner,
      transactionId,
      invoiceList,
      vehicleId: this.vehicleId,
      gpId: this.gpId
    };
    this.selecetdTransaction = filteredTransaction;
    this.bankTransactionsService.setTransactionDetails(
      this.selecetdTransaction
    );
    this.bankTransactionsService.openDrawer();
  }

  isFilterApplied(): boolean {
    const { start, end } = this.range?.value || {};
    const filters = this.filters.getValue();

    return this.selectedFilters.length > 0 || !!start || !!end || Object.values(filters).some(Boolean);
  }

  attachmentPopup(element: any) {
    const id = this.vehicleId;
    const dialogRef = this.dialog.open(InvoiceAttachmentDialogComponent, {
      data: {
        ...element,
        ['vehicleId']: id,
        ['transactionId']: element.transactionId,
        ['gpId']: this.gpId,
        showPdfView: false
      },
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res && res.status == 1) {
        this.refresh.next('refresh');
      }
    });
  }

  unlinkDialog(data: any) {
    const dialogRef = this.dialog.open(DialogComponent, {
      data: <ModalDialogData>{
        titleKey: 'Are you sure to unlink?',
        contentKey: 'Please confirm if you would like to unlink the linked invoices. You will not be able to undo this action once confirmed.',
        positiveMessageKey: 'Yes',
        negativeMessageKey: 'No',
        isValid: '3',
      },
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((res) => {
      if(res == 1) {
        const invoiceIds = Array.isArray(data.invoiceList) ? data.invoiceList
        .filter((invoice: InvoiceItem) => invoice && typeof invoice.id === 'string')
        .map((invoice: InvoiceItem) => invoice.id): [];

        this.bankTransactionsService
        .unlinkInvoice(data.transactionId, invoiceIds)
        .subscribe({
          next: data => {
            this.refresh.next('refresh');
            this.commonService.successNotification(
              'Invoices have been unlinked successfully'
            );
          },
          error: error => {
            this.commonService.errorNotification(
              'Failed to unlink invoices. Please try again later.'
            );
          },
        });
      }
    });
  }
}
interface UnlinkData {
  transactionId: string;
  invoiceList: InvoiceItem[];
  vehicleId: string;
}
@Component({
  selector: 'app-bank-transaction-detail',
  templateUrl: './bank-transaction-detail.component.html',
  styleUrls: ['./bank-transactions.component.scss'],
  // imports: [MenuSelectComponent],
})
export class BankTransactionDetailComponent {
  isLoading = false;
  transactionDetails: any;
  dateFields = ['bookingDate', 'date', 'valueDate'];
  hideFields = ['id', 'valueDate', 'tags'];
  unlinkData: UnlinkData | null = null;
  documentUrl = null;
  refresh = false;
  transactionDetailsValue: any;
  selectedVehicle: any;
  selectedGP: any = {};
  vehicleId: any;
  gpId: any;
  constructor(
    public commonService: CommonService,
    public bankTransactionsService: BankTransactionsService,
    private dialog: MatDialog,
    private config: ConfigService
  ) { }
  ngOnInit() {
    this.bankTransactionsService.setTransationListRefresh(true);
    const baseconfigData = this.config.baseData.data;
    this.bankTransactionsService.transactionDetailsObservable$.subscribe(
      (res: any) => {
        if (res) {
          this.unlinkData = {
            transactionId: res.transactionId,
            invoiceList: res.invoiceList || [],
            vehicleId: res.vehicleId,
          };
          this.vehicleId = res.vehicleId;
          this.gpId = res.gpId;
          this.transactionDetailsValue = res;
          this.transactionDetails = this.objectToArrayOfObjects(res);
        }
      }
    );
    if (this.vehicleId && this.gpId) {
      this.selectedGP = baseconfigData.gps.find((item: any) => item.id === this.gpId);
      this.selectedVehicle = this.selectedGP.vehicles.find(
        (item: any) => item.id === this.vehicleId
      );
    }
    this.bankTransactionsService.selectedVehicleAsObservables$.subscribe((res: any) => {
      if(res) {
        this.selectedVehicle = res;
      }
    });
  }
  objectToArrayOfObjects(obj: any) {
    return Object.entries(obj).map(([key, value]) => ({
      key: key,
      value: value,
    }));
  }

  isObject(item: any) {
    return typeof item === 'object' && item !== null;
  }

  unlinkDialog(unlinkData: InvoiceItem, transactionId?: string) {
    if (transactionId) {
      const dialogRef = this.dialog.open(DialogComponent, {
        data: <ModalDialogData>{
          titleKey: 'Are you sure to unlink?',
          contentKey:
            'Please confirm if you would like to unlink the linked invoices. You will not be able to undo this action once confirmed.',
          positiveMessageKey: 'Yes',
          negativeMessageKey: 'No',
          isValid: '3',
        },
        disableClose: false,
      });
      dialogRef.afterClosed().subscribe(res => {
        if (res == 1 && unlinkData) {
          const invoiceId = unlinkData.id || '';
          this.bankTransactionsService
            .unlinkInvoice(transactionId, [invoiceId])
            .subscribe({
              next: data => {
                this.bankTransactionsService.shouldTriggerRefreshOnClose = true;
                this.bankTransactionsService.setTransationListRefresh(true);
                this.commonService.successNotification(
                  'Invoices have been unlinked successfully'
                );
                this.removelinkData(invoiceId);
              },
              error: error => {
                this.commonService.errorNotification(
                  'Failed to unlink invoices. Please try again later.'
                );
              },
            });
        } else {
          console.log('no result', res);
        }
      });
    }
  }

  removelinkData(invoiceId: string) {
    if (this.unlinkData?.invoiceList) {
      this.unlinkData.invoiceList = this.unlinkData.invoiceList.filter(
        invoice => invoice.id !== invoiceId
      );
    }
  }

  attachmentPopup(
    showpdfView: boolean,
    detailsView: boolean | InvoiceItem,
    viewPdfdata?: InvoiceItem
  ) {
    const dialogRef = this.dialog.open(InvoiceAttachmentDialogComponent, {
      data: {
        ...this.unlinkData,
        vehicleId: this.vehicleId,
        gpId: this.gpId,
        showPdfView: showpdfView,
        detailsView: detailsView,
        viewPdfdata: viewPdfdata || [],
      },
    });
    dialogRef.afterClosed().subscribe(res => {
      if (res && res.status == 1) {
        if (res.ids && res.ids.length > 0) {
          if (this.unlinkData && this.unlinkData?.invoiceList?.length > 0) {
            const existingIds = new Set(
              this.unlinkData.invoiceList.map((i: InvoiceItem) => i.id)
            );
            const newItems = res.ids.filter((i: InvoiceItem) => !existingIds.has(i.id));
            this.unlinkData.invoiceList.push(...newItems);
          } else if (this.unlinkData) {
            this.unlinkData.invoiceList.push(...res.ids);
          }
        }
        this.bankTransactionsService.setTransationListRefresh(true);
      }
    });
  }

  getDocumentUrl(url: any) {
    if (!url) return '';
    return url.startsWith('http')
      ? url
      : `${environment.presignedDomainUrl}${url}`;
  }
}
export interface InvoiceItem {
  invoiceNumber: string;
  documentUrl: string;
  id: string;
}
export interface InvoiceDetail {
  id: string;
  issueDate: string;
  totalAmount: number;
  currency: string;
  status: string;
  invoiceList: InvoiceItem[];
  counterpartyName: string;
  isInvoiceLinked: boolean;
}
@Component({
  selector: 'app-invoice-attachment-dialog',
  templateUrl: './invoice-attachment-dialog.component.html',
  styleUrls: ['./bank-transactions.component.scss'],
})
export class InvoiceAttachmentDialogComponent implements AfterViewInit {
  pdfData: any = {};
  isLoading = true;
  isTableLoading = true;
  displayedColumns: string[] = [
    'invoiceNumber',
    'counterpartyName',
    'issueDate',
    'totalAmount',
    'isTransactionLinked',
    'actions',
  ];
  defaultSortBy = 'issueDate';
  defaultOrderBy: SortDirection = 'desc';
  search: string;
  selectedInvoiceIds: any = [];
  attachmentDetails: any;
  dataSource: MatTableDataSource<any> = new MatTableDataSource([] as any);
  private invoiceSearchSubject = new Subject<boolean>();
  filters: BehaviorSubject<any> = new BehaviorSubject<any>({});
  private sort: MatSort;
  totalItems = 0;
  page: any = 1;
  pageSize: any = 10;
  @ViewChild(MatSort, { static: false })
  set matSort(sort: MatSort) {
    if (sort) {
      this.sort = sort;
      this.dataSource.sort = this.sort;
      this.sort.sortChange.subscribe((value) => {
        // this.sortChange();
      });
    }
  }
  selectedVehicle: any;
  selectedGP: any = {};
  scrollTableLoading = false;

  constructor(
    private bankTransactionsService: BankTransactionsService,
    public dialogRef: MatDialogRef<InvoiceAttachmentDialogComponent>,
    public commonService: CommonService,
    private config: ConfigService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.filters.next({
      sortBy: this.defaultSortBy,
      order: this.defaultOrderBy,
    });
    this.invoiceSearchSubject.pipe(debounceTime(1000)).subscribe(flag => {
      flag && this.searchFilter();
    }); 
    if (this.data.gpId && this.data.vehicleId) {
      const baseconfigData = this.config.baseData.data;
      this.selectedGP = baseconfigData.gps.find((item: any) => item.id === this.data.gpId);
      this.selectedVehicle = this.selectedGP.vehicles.find(
        (item: any) => item.id === this.data.vehicleId
      );
    }
  }

  searchFilter() {
    const filterValue = (this.search || '').trim().toLowerCase();
    this.filters.next({
      sortBy: this.defaultSortBy,
      order: this.defaultOrderBy,
      search: filterValue,
    });
  }

  searchHandler() {
    this.dataSource.data = [];
    this.page = 1;
    this.isTableLoading = true;
    this.invoiceSearchSubject.next(true);
    this.dataSource.data = [];
    this.selectedInvoiceIds = [];
    this.attachmentDetails = '';
  }
  ngAfterViewInit() {
    this.filters.subscribe((d) => {
      this.fetchAttachInvoices();
    });
  }

  fetchAttachInvoices(scrollLoading = false) {
    const currentFilters = this.filters.getValue();
    const sortBy = currentFilters.sortBy || this.defaultSortBy;
    const orderBy = currentFilters.order || this.defaultOrderBy;
    const search = currentFilters?.search;
    if (this.dataSource.data.length > 0 || search) {
      this.isTableLoading = !scrollLoading;
    } else {
      this.isLoading = true;
      this.isTableLoading = !scrollLoading;
    }
    if (scrollLoading) {
      this.scrollTableLoading = true;
    }
    this.bankTransactionsService
      .getAttachInvoices(this.data.vehicleId, sortBy, orderBy, this.page, this.pageSize, search)
      .subscribe({
        next: data => {
          if (data) {
            const parsedResponse = JSON.parse(JSON.stringify(data));
            this.dataSource.data = [...this.dataSource.data, ...parsedResponse.data];
            this.totalItems = parsedResponse.totalCount;
            this.page++;
            this.isTableLoading = false;
            this.scrollTableLoading = false;
          }
        },
        error: error => {
          console.error('Failed to fetch attached invoices:', error);
        },
        complete: () => {
          this.isLoading = false;
          this.isTableLoading = false;
          this.scrollTableLoading = false;
        },
      });
  }

  linkInvoice() {
    if (this.selectedInvoiceIds) {
      const invoiceIds = this.selectedInvoiceIds.map((item: InvoiceItem) => item.id);
      this.bankTransactionsService
        .linkInvoice(this.data.transactionId, invoiceIds)
        .subscribe({
          next: data => {
            this.dialogRef.close();
            this.commonService.successNotification(
              'Invoices have been linked successfully'
            );
          },
          error: error => {
            this.commonService.errorNotification(
              'Failed to link invoices. Please try again later.'
            );
          },
        });
    }
  }

  sortChange() {
    this.dataSource.data = [];
    this.page = 1;
    this.selectedInvoiceIds = [];
    this.attachmentDetails = '';
    const sortBy = this.sort.active;
    const order = this.sort.direction;
    this.filters.next({
      ...this.filters.getValue(),
      sortBy,
      order,
    });
  }

  viewPdf(data: any): void {
    this.data.showPdfView = true;
    this.pdfData = data;
  }

  backButton() {
    this.data.showPdfView = false;
  }

  getDocumentUrl(url: any) {
    this.pdfData['name'] = url.split('/').pop();
    if (!url) return '';
    return url.startsWith('http')
      ? url
      : `${environment.presignedDomainUrl}${url}`;
  }
  handleBackspaceClear(event: KeyboardEvent) {
    const filterValue = (this.search || '').trim().toLowerCase();
    if ((event.key === 'Backspace' || event.key === 'Delete') && !filterValue) {
      // this.clearFilter();
    }
  }

  clearFilter() {
    this.dataSource.data = [];
    this.selectedInvoiceIds = [];
    this.attachmentDetails = '';
    this.page = 1;
    this.search = '';
    this.filters.next({
      ...this.filters.getValue(),
      sortBy: this.defaultSortBy,
      order: this.defaultOrderBy,
      search: null,
    });
  }
  
  selectionChangeValue(event: MatCheckboxChange, invoice: InvoiceItem): void {
    const { id, invoiceNumber, documentUrl } = invoice;
    if (event.checked) {
      this.selectedInvoiceIds.push({ id, invoiceNumber, documentUrl });
    } else {
      this.selectedInvoiceIds = this.selectedInvoiceIds.filter((item: InvoiceItem) => item.id !== id);
    }
  }

  invoiceIdExists(id: string): boolean {
    return this.selectedInvoiceIds.some((item: InvoiceItem) => item.id === id);
  }
  
  onTableScroll(event: any) {
    const tableViewHeight = event.target.offsetHeight;
    const tableScrollHeight = event.target.scrollHeight;
    const scrollLocation = event.target.scrollTop;
    const buffer = 200;
    const limit = tableScrollHeight - tableViewHeight - buffer;
    const loading = this.scrollTableLoading || this.isTableLoading;
    if (scrollLocation > limit && !loading && this.dataSource.data.length < this.totalItems) {
      this.fetchAttachInvoices(true);
    }
  }
}